module.exports = __webpack_public_path__ + "static/IMG_0384-a7e52a53f11d7497f503c80b890837b6.jpg";